module.exports = __webpack_public_path__ + "static/img/A-TFapple-old.ac639b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/A-TFapple-old.png
// module id = CDYB
// module chunks = 3